import { Pipe, PipeTransform } from '@angular/core';

import { InvoiceType } from '~core/models/invoice.models';

@Pipe({
  name: 'invoiceTypeLabel',
  standalone: true
})
export class InvoiceTypeLabelPipe implements PipeTransform {
  private readonly _typeMap: Record<InvoiceType, string> = {
    [InvoiceType.salesInvoice]: 'Facture de vente',
    [InvoiceType.creditNote]: "Facture d'avoir",
    [InvoiceType.proformaInvoice]: 'Facture Proforma',
    [InvoiceType.bapa]: "BAPA (Bordereau d'Achat de Produits Agricoles)"
  };

  transform(type: InvoiceType | null | undefined): string {
    if (!type) return 'Facture';
    return this._typeMap[type];
  }
}
